export function convertMilesToMeters(miles: number): number {
  return miles * 1609.34;
}
